import "dotenv/config"

export const appleAppId = "6474152936"
export const apiBaseUrl = process.env.NEXT_PUBLIC_API_BASE || ""
export const sentryDSN =
  "https://d15f66892ae20ccf9bc42bc4c717062d@o4506300122267648.ingest.us.sentry.io/4510863163064320"
export const appEnv = process.env.NEXT_PUBLIC_VERCEL_ENV || "development"
export const segmentApiKey = process.env.NEXT_PUBLIC_SEGMENT_API_KEY || ""
export const mapsBaseUrl = "/api/maps"
export const placesBaseUrl = `${apiBaseUrl}/places` || ""
export const intercomId = process.env.NEXT_PUBLIC_INTERCOM_ID || ""
export const googlePlacesApiKey =
  process.env.NEXT_PUBLIC_GOOGLE_API_KEY ||
  "AIzaSyBsdvG05WDOAiTdoIQ39iDwdHH_2nrex0I"
export const posthogApiKey =
  process.env.NEXT_PUBLIC_POSTHOG_KEY ||
  "phc_lmYPnhfeiXTsmOCh4zcJulHD2IxgHRTKKHzOT6gGRzU"
export const posthogApiHost =
  process.env.NEXT_PUBLIC_POSTHOG_API_HOST || "https://us.i.posthog.com"
